class Treasury {
  portisKey: undefined | string;

  fortmaticKey: undefined | string;

  get portis() {
    return this.portisKey;
  }

  set portis(key) {
    this.portisKey = key;
  }

  get fortmatic() {
    return this.fortmaticKey;
  }

  set fortmatic(key) {
    this.fortmaticKey = key;
  }
}

export const treasury = new Treasury();
